import { Navigate } from "react-router-dom";

// Client-offer domain (Sourcing Intelligence + Revenue Command Center); the .com keeps the job-seeker side.
export const CLIENT_HOSTS = ["mynextbigmove.co", "www.mynextbigmove.co"];
export const isClientHost = () => CLIENT_HOSTS.includes(window.location.hostname.toLowerCase());
export const PRO_TITLE = "MyNextBigMove.co · for Recruiters & Sales Professionals · powered by RPOPRO.co";
export const SALES_EMAIL = "sales@mynextbigmove.co";
export const BILLING_EMAIL = "accounting@mynextbigmove.co";
export const isProPage = (path) => isClientHost() || path.startsWith("/client/login") || path.startsWith("/client/accept");

if (isClientHost()) document.title = PRO_TITLE;

export const RootRoute = () => <Navigate to={isClientHost() ? "/client/login" : "/search"} replace />;
